import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Loading...", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", {
  class: "mt-4",
  style: {"text-align":"left"}
}, "Almost there", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left"} }, "Send and receive USD Coin from friends and family in Lebanon", -1)
const _hoisted_8 = {
  key: 0,
  id: "validation"
}
const _hoisted_9 = { style: {"display":"flex","column-gap":"10px"} }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  href: "https://getsinbad.com",
  id: "logo"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 mt-5" }, "Your Sinbad USD balance:", -1)
const _hoisted_14 = {
  id: "balance",
  class: "mt-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 mt-4" }, "Your wallet address:", -1)
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  id: "address",
  class: "mt-3",
  title: "Click to view on polygonscan"
}
const _hoisted_18 = {
  class: "mt-3",
  style: {"width":"100%","padding-bottom":"60px"}
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "check" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "m14 21.591l-5-5L10.591 15L14 18.409L21.41 11l1.595 1.585L14 21.591z"
  })
], -1)
const _hoisted_22 = {
  key: 1,
  style: {"padding-bottom":"60px"}
}
const _hoisted_23 = { id: "leaderboard" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "Leaderboards", -1)
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", {
  class: "mt-4",
  style: {"text-align":"left"}
}, "Sign Up", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"left"} }, "You'll be ready to send test crypto over the blockchain in a few seconds.", -1)

import { initializeApp } from "firebase/app";
import { collection, onSnapshot, getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import {
	getFunctions,
	httpsCallable,
	connectFunctionsEmulator,
} from "firebase/functions";

import BackArrow from "@/components/BackArrow.vue"
import SinbadLogo from "@/components/SinbadLogo.vue"
import SinbadToken from "@/components/SinbadToken.vue"

import { ref, onMounted, onUnmounted, computed } from "vue";

import { Web3Auth } from "@web3auth/modal";
import { CHAIN_NAMESPACES, SafeEventEmitterProvider, WALLET_ADAPTERS } from "@web3auth/base";
import { OpenloginAdapter } from "@web3auth/openlogin-adapter";
import RPC from "./web3RPC";
import { isAddress } from "web3-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let provider = ref<SafeEventEmitterProvider | any>(false);
const loggedin = computed(() => provider.value !== false);
const allUsers = ref<any[]>([]);
const activeUser = computed(() => allUsers.value.find(user => user.address == address.value))
const userCreated = computed(() => activeUser.value != undefined && activeUser.value.username)
const usernameInput = ref<string>("")
const showLeaderboard = ref(false)
const leaderboard = computed(() => {
	if (Array.isArray(allUsers.value)) {
		const usersWithBalance = allUsers.value.filter((user) => !Number.isNaN(Number(user.balance)))
		return usersWithBalance.sort((a, b) => Number(b.balance) - Number(a.balance))
	} else return []
})
const address = ref<string>("")
const loginMethod = ref<string>("")
const toast = ref<any>(null);
const validationMessage = ref<string>("")
const loading = ref<boolean>(false);

// Initialize Firebase
const firebaseConfig = {
	apiKey: "AIzaSyBGqa-ej3sUNcjrSuYZlBzrqDTOPYnsR-c",
	authDomain: "sinbad-website.firebaseapp.com",
	projectId: "sinbad-website",
	storageBucket: "sinbad-website.appspot.com",
	messagingSenderId: "150771956500",
	appId: "1:150771956500:web:5b24e5fb3817de6bc16001",
	measurementId: "G-8Z4DLTNDRQ",
};
const app = initializeApp(firebaseConfig);
const functions = getFunctions(app);
const db = getFirestore(app);

if (process.env.NODE_ENV == "development") {
	connectFunctionsEmulator(functions, "localhost", 5001);
	try {
		connectFirestoreEmulator(db, "localhost", 8080);
	} catch (error: any) {
		if (error.code != "failed-precondition") throw error
	}
}

// Get existing users and stream updates
const unsubscribeFromCollection = onSnapshot(collection(db, "demoUsers"), (snapshot) => {
	const users = snapshot.docs.map(doc => doc.data())
	allUsers.value = users
});

// Initialize web3auth
const clientId = "BBRpv-kjMGXffPhCgHMFgUzFutWoSiM8BGxhQW9BVuf3MXVmMCZUXst5AdkhnbeZ_A7JyMC1POMBXy7IUThZt_k";
const web3auth = new Web3Auth({
	clientId,
	web3AuthNetwork: "testnet",
	chainConfig: {
		chainNamespace: CHAIN_NAMESPACES.EIP155,
		chainId: "0x13881", // hex of 80001, polygon testnet
		rpcTarget: "https://polygon-mumbai.g.alchemy.com/v2/yG_4ygDopiz1xR37LOXoH5uCtA_FZdxt",
		displayName: "Polygon Mumbai Testnet",
		blockExplorer: "https://mumbai.polygonscan.com/",
		ticker: "MATIC",
		tickerName: "Matic",
	},
	uiConfig: {
		defaultLanguage: "en",
		appName: "Sinbad",
		theme: "dark",
		appLogo: 'https://firebasestorage.googleapis.com/v0/b/sinbad-website.appspot.com/o/sinbad-logo.svg?alt=media&token=30524c5b-db90-4a04-9c6f-e903042f2a6c',
		loginMethodsOrder: ["google", "facebook", "twitter", "linkedin", "apple"]
	},
});

const openloginAdapter = new OpenloginAdapter({
	adapterSettings: {
		whiteLabel: {
			name: "Sinbad",
			logoDark: "https://firebasestorage.googleapis.com/v0/b/sinbad-website.appspot.com/o/sinbad-logo.svg?alt=media&token=30524c5b-db90-4a04-9c6f-e903042f2a6c",
			defaultLanguage: "en",
			dark: true, // whether to enable dark mode. defaultValue: false
			theme: {
				["primary"]: "#4f5dfb"
			},
		},
	},
	loginSettings: {
		mfaLevel: "none",
	}
});
web3auth.configureAdapter(openloginAdapter);

// Helper functions
function delay(time: number) {
	return new Promise(resolve => setTimeout(resolve, time));
}

const showToast = async (message: string) => {
	if (toast.value) {
		toast.value.innerHTML = message
		toast.value.classList.add("show")
		await delay(5000)
		toast.value.classList.remove("show")
	}
}

const checkButton = async (target: HTMLButtonElement) => {
	target.disabled = true
	target.classList.add("success")
	await delay(5000)
	target.disabled = false
	target.classList.remove("success")
}

const toggleLeaderboard = function () {
	showLeaderboard.value = !showLeaderboard.value
}

// Web3auth methods
const getAddress = async () => {
	try {
		if (!provider.value) {
			console.log("provider not initialized yet");
			return;
		}
		const rpc = new RPC(provider.value);
		address.value = await rpc.getAccounts();
	} catch (error) {
		console.log("Error getting account:", "error")
	}
};

const login = async () => {
	try {
		if (!web3auth) {
			console.log("web3auth not initialized yet");
			return;
		}
		provider.value = await web3auth.connect();
		await getAddress()
		await getLoginMethod();
	} catch (error) {
		console.log("Error logging in:", error)
	}
};

const getLoginMethod = async () => {
	if (!provider.value) {
		console.log("provider not initialized yet");
		return;
	}
	const { typeOfLogin } = await web3auth.getUserInfo();
	loginMethod.value = typeOfLogin as string
}

const sendTransfer = async (event: MouseEvent, toAddress: string) => {
	const target = event.currentTarget as HTMLButtonElement
	try {
		if (!provider.value) {
			console.log("provider not initialized yet");
			return;
		}
		const funds = parseInt(activeUser.value.balance!)
		if (Number.isNaN(funds)) return showToast("Please wait until your balance has loaded")
		if (funds < 10) return showToast("Insufficient funds")

		const rpc = new RPC(provider.value);
		const payload = await rpc.getTransferPayload(toAddress);
		const sendTransfer = httpsCallable<{}, any>(functions, 'sendTransfer')
		loading.value = true
		const { data } = await sendTransfer({ payload })
		checkButton(target)
		showToast(`Transfer sent successfully. <a href="https://mumbai.polygonscan.com/tx/${data.transactionHash}" target="_blank">click here to view the transaction.</a>`)
	} catch (error) {
		console.log("Error sending transaction:", error)
		showToast("Error completing transfer")
	} finally {
		loading.value = false
	}
};

const logout = async () => {
	try {
		if (!web3auth) {
			console.log("web3auth not initialized yet");
			return;
		}
		loading.value = true
		await web3auth.logout()
		provider.value = false
		usernameInput.value = ''
		loginMethod.value = ''
		validationMessage.value = ''
		address.value = ''
		showLeaderboard.value = false
		login()
	} catch (error) {
		console.log("Error logging out:", error)
	} finally {
		loading.value = false
	}
};

// Firebase callable
const createDemoUser = async () => {
	validationMessage.value = ""

	if (usernameInput.value.length < 3 || usernameInput.value.length > 20) return validationMessage.value = "Usernames must be at 3 to 20 characters"
	if (usernameInput.value.length < 3 || usernameInput.value.length > 20) return validationMessage.value = "Usernames must be at 3 to 20 characters"
	if (!isAddress(address.value)) return validationMessage.value = "Your address has not been initialized, please try again."

	const createUser = httpsCallable<{ address: string, username: string, loginMethod: string }, { usernameExists?: boolean, addressExists?: boolean }>(functions, 'createDemoUser')

	loading.value = true
	const { data } = await createUser({ address: address.value, username: usernameInput.value, loginMethod: loginMethod.value })
	loading.value = false

	if (data.usernameExists) return validationMessage.value = "Sorry, but it appears that username is already taken"
	if (data.addressExists) return validationMessage.value = "There is already a user associated with your wallet address. This is likely an internal error, please contact us for details."
}

onMounted(async () => {
	try {
		loading.value = true
		await web3auth.initModal({
			modalConfig: {
				[WALLET_ADAPTERS.TORUS_EVM]: { label: "torus", showOnModal: false, },
				[WALLET_ADAPTERS.METAMASK]: { label: "metamask", showOnModal: false, },
				[WALLET_ADAPTERS.WALLET_CONNECT_V2]: { label: "Wallet Connect V2", showOnModal: false, },
				[WALLET_ADAPTERS.WALLET_CONNECT_V1]: { label: "Wallet Connect V1", showOnModal: false, },
			},
		});
		loading.value = false

		if (web3auth.provider) {
			// Already logged in
			provider.value = web3auth.provider;
			await getAddress()
			await getLoginMethod();
		} else {
			// not logged in
			await login()
		}
	} catch (error) {
		console.log("Error on mount:", error);
	}
});

onUnmounted(() => {
	unsubscribeFromCollection();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(SinbadToken, { class: "loader" }),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_unref(loggedin) && !_unref(userCreated))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter a username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameInput).value = $event))
            }, null, 512), [
              [
                _vModelText,
                usernameInput.value,
                void 0,
                { trim: true }
              ]
            ]),
            (validationMessage.value.length > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(validationMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "outline-button",
                style: {"margin-top":"2rem","font-weight":"600"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (logout()))
              }, " Sign out "),
              _createElementVNode("button", {
                class: "filled-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (createDemoUser()))
              }, " Continue ")
            ])
          ]))
        : (_unref(loggedin) && _unref(userCreated))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (!showLeaderboard.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("a", _hoisted_12, [
                          _createVNode(SinbadLogo, { height: "20px" })
                        ]),
                        _hoisted_13,
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_14, [
                            (_unref(activeUser).balance)
                              ? (_openBlock(), _createBlock(SinbadToken, { key: 0 }))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(_unref(activeUser).balance ?? "Loading..."), 1)
                          ])
                        ]),
                        _hoisted_15,
                        _createElementVNode("a", {
                          href: 'https://mumbai.polygonscan.com/address/' + _unref(activeUser).address,
                          target: "_blank"
                        }, [
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(activeUser).address), 1)
                        ], 8, _hoisted_16),
                        _createElementVNode("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUsers.value, (user) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: user.username
                            }, [
                              (user.username !== _unref(activeUser).username)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "outline-button",
                                    onClick: ($event: any) => (sendTransfer($event, user.address))
                                  }, [
                                    _createElementVNode("span", null, [
                                      _createTextVNode("Send "),
                                      _createVNode(SinbadToken),
                                      _createTextVNode("10 to " + _toDisplayString(user.username), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _hoisted_21,
                                      _createElementVNode("p", null, [
                                        _createTextVNode(" Sent "),
                                        _createVNode(SinbadToken),
                                        _createTextVNode("10 to " + _toDisplayString(user.username) + "! ", 1)
                                      ])
                                    ])
                                  ], 8, _hoisted_19))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128)),
                          _createElementVNode("footer", null, [
                            _createElementVNode("button", {
                              class: "filled-button",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (logout()))
                            }, " Sign out "),
                            _createElementVNode("button", {
                              class: "filled-button",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleLeaderboard()))
                            }, " Leaderboards ")
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_TransitionGroup, { name: "list" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leaderboard), (user, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: user.username,
                                  class: "leaderboard-user"
                                }, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", null, _toDisplayString(`${index + 1}. ${user.username}`), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", null, [
                                      _createVNode(SinbadToken),
                                      _createTextVNode(_toDisplayString(user.balance), 1)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("footer", null, [
                          _createElementVNode("button", {
                            class: "filled-button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleLeaderboard()))
                          }, [
                            _createVNode(BackArrow),
                            _createTextVNode(" Back to homepage ")
                          ])
                        ])
                      ]))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _hoisted_27,
              _createElementVNode("button", {
                class: "filled-button",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (login()))
              }, " Get started ")
            ])),
      _createElementVNode("div", {
        id: "toast",
        ref_key: "toast",
        ref: toast
      }, null, 512)
    ])
  ]))
}
}

})